module.exports = __webpack_public_path__ + "static/media/ic_barrage.f32d0bd9.png";